import classnames from 'classnames/bind'
import React from 'react'

import Client, { ClientProps } from '~/components/Client'
import ImageWithPlaceholder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import { ReactComponent as DropdownIcon } from './quote.svg'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface PersonProps {
  name?: RichTextBlock[]
  role?: RichTextBlock[]
  business?: ClientProps
}

export interface QuoteProps {
  className?: string
  text?: RichTextBlock[]
  backgroundColor?: string
  textColor?: string
  person?: PersonProps
  big?: boolean
  image?: ImageWithPlaceholderProps
  index?: number
}

function Quote({
  className,
  person,
  text,
  textColor,
  backgroundColor,
  big = false,
  image,
  index,
}: QuoteProps) {
  const textStyle = useStyle({
    textPreset: big ? 'title-content' : 'text-paragraph',
  })
  const nameStyle = useStyle({ textPreset: 'text-body' })
  const roleStyle = useStyle({ textPreset: 'text-caption' })

  const isOdd = index % 2 !== 0

  return (
    <div className={cx(css.Quote, className, { big, isOdd, hasImage: image })}>
      {!isOdd && image && (
        <div className={css.imageContainer}>
          <ImageWithPlaceholder layout="fill" objectFit="cover" {...image} />
        </div>
      )}
      <div className={css.content}>
        <DropdownIcon className={css.icon} />
        <div className={css.separator} />
        {text && <RichText className={cx(textStyle, css.text)} render={text} />}
        {person && (
          <div className={css.person}>
            {person?.name && (
              <div className={cx(nameStyle, css.name)}>{person.name}</div>
            )}
            {person?.role && (
              <div className={cx(roleStyle, css.role)}>{person.role}</div>
            )}
            {person?.business && (
              <Client
                className={css.client}
                {...person.business}
                responsive
                objectPosition="0% 50%"
              />
            )}
          </div>
        )}
        <div className={css.separator} />
      </div>
      {isOdd && image && (
        <div className={css.imageContainer}>
          <ImageWithPlaceholder layout="fill" objectFit="cover" {...image} />
        </div>
      )}
    </div>
  )
}

Quote.defaultProps = {}

export default Quote
